import React__default, { useContext, useRef, useEffect, createContext, useMemo } from 'react';

// NOOPs for server and before init
var noop = function noop() {};
var noopObserver = {
  observe: noop,
  unobserve: noop,
  disconnect: noop
};
var VisibilityObserverContext = /*#__PURE__*/createContext(noopObserver);
var useVisibilityObservable = function useVisibilityObservable() {
  var observer = useContext(VisibilityObserverContext);
  var el = useRef(null);
  useEffect(function () {
    var current = el.current;
    if (!current) {
      return;
    }
    observer.observe(current);
    return function () {
      return observer.unobserve(current);
    };
  }, [observer]);
  return el;
};
var VisibilityObserver = function VisibilityObserver(_ref) {
  var children = _ref.children,
    onObservable = _ref.onObservable,
    _ref$root = _ref.root,
    root = _ref$root === void 0 ? null : _ref$root,
    _ref$rootMargin = _ref.rootMargin,
    rootMargin = _ref$rootMargin === void 0 ? "100px" : _ref$rootMargin,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? 0 : _ref$threshold;
  // Reference to observer function, required to use indirection to avoid'
  // having to recreate the IntersectionObserver unless necessary.
  var cbRef = useRef(onObservable);

  // Update ref to the observer function
  cbRef.current = onObservable;
  var observer = useMemo(function () {
    return typeof IntersectionObserver !== "undefined" ? new IntersectionObserver(function (x) {
      return cbRef.current(x);
    }, {
      root: root,
      rootMargin: rootMargin,
      threshold: threshold
    }) : noopObserver;
  }, [root, rootMargin, threshold]);

  // Remove the intersection observer when we die or change params
  useEffect(function () {
    return function () {
      return observer.disconnect();
    };
  }, [observer]);
  return /*#__PURE__*/React__default.createElement(VisibilityObserverContext.Provider, {
    value: observer
  }, children);
};

export { VisibilityObserver, useVisibilityObservable };
//# sourceMappingURL=context.js.map
